import script from "./OnboardingCalculationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingCalculationStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingCalculationStep.vue?vue&type=style&index=0&id=6cfd336f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfd336f"]])

export default __exports__